// http://www.xtf.dk/2011/08/center-new-popup-window-even-on.html
function PopupCenter(url, target, w, h)
{
	// Fixes multi-monitor position                         Most browsers      Firefox
	let multiMonitorLeft = window.screenLeft != undefined ? window.screenLeft : screen.left;
	let multiMonitorTop = window.screenTop != undefined ? window.screenTop : screen.top;

	let width = window.innerWidth ? window.innerWidth : document.documentElement.clientWidth ? document.documentElement.clientWidth : screen.width;
	let height = window.innerHeight ? window.innerHeight : document.documentElement.clientHeight ? document.documentElement.clientHeight : screen.height;

	let left = ((width / 2) - (w / 2)) + multiMonitorLeft;
	let top = ((height / 2) - (h / 2)) + multiMonitorTop;
	let newWindow = window.open(url, target, 'scrollbars=yes, width=' + w + ', height=' + h + ', top=' + top + ', left=' + left);

	// Puts focus on the newWindow
	if (window.focus) {
		newWindow.focus();
	}
}

export default function () {
	let popupLinks = document.querySelectorAll('.jsPopup');
	popupLinks.forEach(link => {
		link.addEventListener('click', (e) => {
			e.preventDefault();
			PopupCenter(
				link.href,
				link.target,
				'640',
				'480'
			)
		});
	});
}
